import React from 'react';
import SectionTab from 'constants/SectionTab';
import ContactUs from 'modules/contactform';
import AboutUs from 'modules/aboutus';
import FAQ from 'modules/faq';
import History from 'modules3/history';
import PodCastPopular from 'modules3/popular';
import PodCastFiveStar from 'modules3/fiveStar';
import { Genres, GenresPodCast } from 'modules3/genres';
import Search from 'modules3/search';
import {
  PodCastDetailCard,
  PodCastEpisodeCard
} from 'modules3/podcast/components';

const ContentArea = (props) => {
  const { currentTab, position, audioPlayer } = props;

  const getActiveSection = () => {
    switch (currentTab) {
      case SectionTab.PodCastDetail:
        return <PodCastDetailCard audioPlayer={audioPlayer} />;
      case SectionTab.PodCastFavourite:
        return <History />;
      default:
        return <History />;
    }
  };

  const getActiveTab = () => {
    switch (currentTab) {
      case SectionTab.Contact:
        return <ContactUs />;
      case SectionTab.About:
        return <AboutUs />;
      case SectionTab.Faq:
        return <FAQ />;
      case SectionTab.FiveStar:
        return <PodCastFiveStar />;
      case SectionTab.Genres:
        return <Genres />;
      case SectionTab.SearchPodCast:
        return <Search />;
      case SectionTab.GenreStation:
        return <GenresPodCast />;
      case SectionTab.PodCastDetail:
        return <PodCastEpisodeCard audioPlayer={audioPlayer} />;
      default:
        return <PodCastPopular />;
    }
  };

  return position === 'top' ? (
    <div className="main-content-area" id="top-content-area">
      {getActiveSection()}
    </div>
  ) : (
    <div className="main-content-area" id="main-content-area">
      {getActiveTab()}
    </div>
  );
};

export default ContentArea;
